export class Name {
    first: string;
    last: string;
    middle: string;
    goesBy: string;
    prefix: string;
    suffix: string;

    constructor(obj?: Partial<Name>) {
        Object.assign(this, obj);
    }

    getFullName(lastNameFirst = false, withSuffix = false, withPrefix = false) {
        let fullName: string = lastNameFirst
            ? `${this.last}, ${this.first}`
            : `${this.first} ${this.last}`;
        fullName = withPrefix ? `${this.prefix} ${fullName}` : fullName;
        fullName = withSuffix ? `${fullName} ${this.suffix}` : fullName;
        return fullName;
    }
}
